import React, {Fragment} from 'react';
import {
  Container,
  Row,
  Col
} from 'reactstrap';
import Button from '../Button/Button';
import {Link} from 'react-router-dom';
import styled from 'styled-components';

const SectionLink = styled(Link)`
  color: #2b68b2;
  transition: 0.4s ease all;

  :hover {
    text-decoration: none;
    color: #23b6ea;
  }
`;


const Instructions = props => {

  const {
    handleNextLink,
    endOfSection,
    sectionComplete,
    handleComplete,
    pathBase
  } = props;

  return (
    <Container>
      <Row>
        <Col lg={2} />
        <Col sm={12} lg={8}>
          {endOfSection ? (
            <Fragment>
              {sectionComplete ? (
                <p>This section is now complete. You may go back and review any of your answers or can complete this section to go onto another.</p>
              ) : (
                <p>There are still more questions needed to be answered to complete this section. Please go back and review the needed information.</p>
              )}
              <hr style={{marginTop:'40px'}} />
              <div style={{display:'inline-block',verticalAlign:'top'}}>
                <SectionLink to={`/${pathBase}`}>Return to Sections</SectionLink>
              </div>
              <div style={{textAlign:'right'}}>
                <Button
                  click={handleComplete}
                  color='#28b536'
                  marginRight='10px'
                  disabled={!sectionComplete}
                >FINISH SECTION</Button>
                <Button click={handleNextLink}>REVIEW</Button>
              </div>
            </Fragment>
          ) : (
            <Fragment>
              <p>Consider each question and answer from the choices presented.
                Select the NEXT button to start. Once this section is completed hit the FINISH button to select the next
                questionnaire section or the REVIEW button to retrace the current section. Select the Return to Sections phrase
                to return to the section screen at any time.</p>
              <hr style={{marginTop:'40px'}} />
              <div style={{display:'inline-block',verticalAlign:'top'}}>
                <SectionLink to={`/${pathBase}`}>Return to Sections</SectionLink>
              </div>
              <div style={{textAlign:'right'}}>
                <Button click={handleNextLink}>NEXT</Button>
              </div>
            </Fragment>
          )}
        </Col>
        <Col lg={2} />
      </Row>
    </Container>
  );
};

export default Instructions;
